module.exports = __webpack_public_path__ + "static/img/ok1.d26810a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aqua_harps4_com/images/ok1.png
// module id = 663
// module chunks = 0